import { render, staticRenderFns } from "./Vault.vue?vue&type=template&id=20764176&scoped=true"
import script from "./Vault.vue?vue&type=script&lang=js"
export * from "./Vault.vue?vue&type=script&lang=js"
import style0 from "./Vault.vue?vue&type=style&index=0&id=20764176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20764176",
  null
  
)

export default component.exports